import useGlobalStyles from '@/styles/global.styles';

import useStyles from './Eyebrow.styles';

interface EyebrowContent {
  text: string;
  isOnDark?: boolean;
  className?: string;
}

export default function Eyebrow({
  text,
  isOnDark = true,
  className,
  ...props
}: EyebrowContent): React.JSX.Element {
  const { classes: globalClasses } = useGlobalStyles({ fixed: false });
  const { classes, cx } = useStyles();

  return (
    <p
      className={cx(
        globalClasses.eyebrow,
        classes.eyebrow,
        isOnDark ? classes.onDark : classes.onLight,
        className
      )}
      {...props}
    >
      {text}
    </p>
  );
}
